import type { LektionsBlock, SlotTyp, VisatBlock } from '../types'
import BlockKort from './BlockKort'

const SLOT_ETIKETT: Record<SlotTyp, string> = {
  uppstart: 'Uppstart',
  input: 'Genomgång',
  huvudaktivitet: 'Huvudaktivitet',
  examination: 'Examination',
}

/** Ett moment (slot) i lektionens huvudförslag med möjlighet att byta ut det mot
 *  ett likvärdigt, färdigt alternativ. Huvudförslaget är valt som standard;
 *  finns alternativ visas en växlare (Huvudförslag · Alternativ …) och det valda
 *  blocket renderas nedanför. Examination ligger fast och saknar alternativ.
 *  Valet ägs av lektionssidan (så tid, tavelvyer och bildspel följer med). */
export default function SlotKort({
  block,
  nummer,
  valtIndex,
  onValj,
}: {
  block: LektionsBlock
  nummer: number
  valtIndex: number
  onValj: (index: number) => void
}) {
  // index 0 = huvudförslaget, 1..N = alternativ[index-1]
  const alternativ = block.alternativ ?? []
  const harAlternativ = alternativ.length > 0
  const aktivt: VisatBlock = valtIndex === 0 ? block : (alternativ[valtIndex - 1] ?? block)
  const byterFrånHuvud = valtIndex !== 0

  return (
    <div className={`slotkort${byterFrånHuvud ? ' slotkort-bytt' : ''}`}>
      <div className="slotkort-huvud">
        <span className="slotkort-nr">{nummer}</span>
        {block.slot && <span className="slot-badge">{SLOT_ETIKETT[block.slot]}</span>}
        {block.slot === 'examination' && <span className="slot-fast">Ligger fast</span>}
      </div>

      {harAlternativ && (
        <div className="slotvaxlare no-print" role="group" aria-label="Byt moment mot ett alternativ">
          <button type="button" className={valtIndex === 0 ? 'aktiv' : ''} onClick={() => onValj(0)}>
            Huvudförslag
          </button>
          {alternativ.map((alt, i) => (
            <button key={`${alt.block_id}-${i}`} className={valtIndex === i + 1 ? 'aktiv' : ''} type="button" onClick={() => onValj(i + 1)}>
              {alt.namn}
            </button>
          ))}
        </div>
      )}

      <BlockKort block={aktivt} />
    </div>
  )
}
